export const Tag = {}

export default Tag
